module.exports = __webpack_public_path__ + "img/evolution_breweries.93542a0c.png";